export function subscribeNewsletterRequest(
  [email, allowDataCollection, allowDataCollectionForMarketing]
) {
  return {
    email,
    allowDataCollectionForMarketing
  };
}

export function submitContactFormRequest([name, email, phone, message, allowDataCollection]) {
  return {
    name,
    email,
    phone,
    message,
    allowDataCollection
  };
}



// WEBPACK FOOTER //
// src/services/contact/requests.js